import type { LinkProps } from "react-router-dom";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import React from "react";

interface ActiveLinkProps extends LinkProps {
  activeClassName?: string;
  children?: React.ReactNode;
}

const ActiveLink = React.forwardRef<
  HTMLAnchorElement,
  ActiveLinkProps & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">
>((props, ref) => {
  const { to, className, activeClassName = "active", ...rest } = props;

  return (
    <NavLink
      className={({ isActive }) =>
        classNames(className, {
          [activeClassName]: isActive,
        })
      }
      ref={ref}
      to={to}
      {...rest}
    />
  );
});

export default ActiveLink;
